<template>
  <el-header>
    <head>
      <title>{{user.conferenceName}}-会议投审稿系统</title>
    </head>
    <!-- <Hamburger id="hamburger-container" @toggleClick="toggleSideBar" /> -->
    <i v-if="$store.state.app.collapse" class="el-icon-s-fold toggle" @click="toggleSideBar" />
    <i v-else class="el-icon-s-unfold toggle" @click="toggleSideBar" />
    <!-- 面包屑 开始 -->
    <breadcrumb-view id="breadcrumb" :path="path"></breadcrumb-view>
    <!-- 面包屑 结束 -->
    <el-menu class="el-menu-demo" mode="horizontal" @select="handleSelect">
      <el-menu-item class="topLab" index="1">{{user.currRole}}</el-menu-item>
      <el-submenu class="topLab" index="2">
        <template slot="title"><span class="menu-title">{{user.appellation}}</span></template>
        <el-menu-item index="2-1" @click="chooseLanguage">{{$t('language.name')}}</el-menu-item>
        <el-menu-item v-if="user.ifChair" index="2-2" @click="editProfile">{{$t('header.profile')}}</el-menu-item>
        <el-submenu v-if="!user.ifChair && !user.ifCochair" index="2-3">
          <template slot="title">{{$t('header.switchRole')}}</template>
          <el-menu-item v-for="(role, roleIndex) in roleList" :key="roleIndex"
                        class="menu-left" index="'2-3-' + roleIndex"
                        @click="chooseRole(role)">{{role}}</el-menu-item>
        </el-submenu>
        <el-menu-item v-if="user.ifChair || user.ifCochair" index="2-4" @click="resetPwd">{{$t('header.rePwd')}}</el-menu-item>
        <el-menu-item index="2-5" @click="logout">{{$t('header.logout')}}</el-menu-item>
      </el-submenu>
    </el-menu>

    <!-- 修改用户信息面板 开始 -->
    <el-dialog ref="profileForm" title="ProfileEdit" :visible.sync="editProfileVisible">
      <el-form :model="profileForm" ref="profileForm" :rules="profileFormRules">
        <el-form-item :label="$t('header.userName')" prop="adminName">
          <el-input v-model="profileForm.adminName" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item :label="$t('header.email')" prop="email">
          <el-input v-model="profileForm.email" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="reset_button" @click="editProfileVisible = false">{{$t('button.cancel')}}</el-button>
        <el-button class="submit_button" @click="saveProfileSubmit">{{$t('button.submit')}}</el-button>
      </div>
    </el-dialog>
    <!-- 修改用户面板 结束 -->

    <!-- 修改密码面板 开始 -->
    <el-dialog ref="pwdForm" title="PasswordEdit" :visible.sync="editPwdVisible">
      <el-form :model="pwdForm" ref="pwdForm" :rules="pwdFormRules">
        <el-form-item :label="$t('header.userName')" prop="adminName">
          <el-input v-model="pwdForm.adminName" autocomplete="off" readonly></el-input>
        </el-form-item>
        <el-form-item :label="$t('header.password')" prop="password">
          <el-input :type="show" v-model="pwdForm.password" autocomplete="off">
            <i slot="suffix" class="el-icon-view" @click="showPass"></i>
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('header.passwordConfirm')" prop="passwordConfirm">
          <el-input :type="showConfirm" v-model="pwdForm.passwordConfirm" autocomplete="off">
            <i slot="suffix" class="el-icon-view" @click="showPassConfirm"></i>
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="reset_button" @click="editPwdVisible = false">{{$t('button.cancel')}}</el-button>
        <el-button class="submit_button" @click="savePwdSubmit">{{$t('button.submit')}}</el-button>
      </div>
    </el-dialog>
    <!-- 修改密码面板 结束 -->
  </el-header>
</template>

<script>
import Md5 from 'js-md5'
import chairMenuList from '../../static/chair-menu.json'
import orgMenuList from '../../static/user-menu.json'
export default {
  name: 'MyHeader',
  props: ['path'],
  data () {
    return {
      editProfileVisible: false,
      fileLimit: 1,
      profileForm: {
        conferenceId: 0,
        adminName: '',
        email: ''
      },
      editPwdVisible: false,
      pwdForm: {
        conferenceId: 0,
        adminName: '',
        password: '',
        passwordConfirm: ''
      },
      show: 'password',
      showConfirm: 'password',
      roleList: [],
      user: {
        currRole: '',
        ifChair: '',
        ifCochair: '',
        conferenceName: ''
      },
      ifSmallDevice: (window.innerWidth < 481),
      conferenceId: this.$route.params.co_id,
      pwdFormRules: {
        adminName: [{required: true, message: this.$t('header.rule.adminName'), trigger: 'blur'}],
        password: [{required: true, message: this.$t('header.rule.password'), trigger: 'blur'}],
        passwordConfirm: [{required: true, trigger: 'blur', validator: this.pwdValidator}]
      },
      profileFormRules: {
        adminName: [{required: true, message: this.$t('header.rule.adminName'), trigger: 'blur'}],
        email: [{required: true, message: this.$t('header.rule.email'), trigger: 'blur'}]
      }
    }
  },
  mounted: function () {
    this.searchRoles()
  },
  methods: {
    searchRoles () {
      this.roleList = JSON.parse(localStorage.getItem('roleList'))
      if (localStorage.getItem('user')) {
        this.user = JSON.parse(localStorage.getItem('user'))
        console.log(this.user)
      }
    },
    handleSelect: function (val) {
      console.log('select')
    },
    chooseLanguage: function () {
      this.$myaxios.post('curr/language/update', this.profileForm)
        .then(function (response) {
          if (response.data.code === '0000') {
            this.editProfileVisible = false
            var language = response.data.entity
            this.$i18n.locale = language
            localStorage.setItem('language', language)
            location.reload()
          }
        }.bind(this))
        .catch(function (error) {
          console.log(error)
        })
    },
    editProfile: function () {
      if (this.$refs.profileForm.rules) {
        this.$refs.profileForm.clearValidate()
      }
      this.$myaxios.post('cochair/curr/profile')
        .then(function (response) {
          if (response.data.code === '0000') {
            var entity = response.data.entity
            this.editProfileVisible = true
            this.profileForm = {
              conferenceId: entity.conferenceId,
              adminName: entity.adminName,
              email: entity.email
            }
          }
        }.bind(this))
        .catch(function (error) {
          console.log(error)
        })
    },
    saveProfileSubmit: function () {
      this.$refs.profileForm.validate((valid) => {
        if (valid) {
          this.$myaxios.post('chair/curr/update', this.profileForm)
            .then(function (response) {
              if (response.data.code === '0000') {
                this.editProfileVisible = false
                this.$myaxios.post('curr/user', {
                })
                  .then(function (response2) {
                    var entity = response2.data.entity
                    var user = {
                      conferenceId: entity.conferenceId,
                      conferenceName: entity.conferenceName,
                      ifChair: entity.ifChair,
                      ifCochair: entity.ifCochair,
                      userId: entity.userId,
                      userEmail: entity.userEmail,
                      appellation: entity.appellation,
                      currRole: entity.currRole,
                      language: entity.language,
                      submitPaperFlag: entity.submitPaperFlag
                    }
                    localStorage.setItem('user', JSON.stringify(user))
                  })
                  .catch(function (error) {
                    console.log(error)
                  })
              }
            }.bind(this))
            .catch(function (error) {
              console.log(error)
            })
        }
      })
    },
    chooseRole: function (roleTitle) {
      this.$myaxios.post('curr/choose/role', {
        roleTitle: roleTitle
      })
        .then(function (response) {
          var user = JSON.parse(localStorage.getItem('user'))
          user.currRole = roleTitle
          localStorage.setItem('user', JSON.stringify(user))
          this.getCurrUser()
        }.bind(this))
        .catch(function (error) {
          console.log(error)
        })
    },
    async getIsShowCertificate() {
      await this.$myaxios
      .post("config/findByAttrCode1?attrCode=isShowCertificate&conferenceId=" + this.$route.params.co_id)
      .then(
        function(response) {
          if (response.data.code='0000') {
            localStorage.setItem("isShowCertificate", response.data.entity);
          }else{
            localStorage.setItem("isShowCertificate", '0');
          }
        }.bind(this)
        )
        .catch(function(error) {
          console.log(error);
          localStorage.setItem("isShowCertificate", '0');
      });
    },
    getCurrUser: function () {
      if (localStorage.getItem('isShowCertificate') != '1') {
        this.getIsShowCertificate()
      }
      let self = this
      this.$myaxios.post('curr/user', {
      })
        .then(function (response2) {
          var entity = response2.data.entity
          var roleList = entity.roleList
          var user = {
            conferenceId: entity.conferenceId,
            conferenceName: entity.conferenceName,
            ifChair: entity.ifChair,
            ifCochair: entity.ifCochair,
            userId: entity.userId,
            userEmail: entity.userEmail,
            appellation: entity.appellation,
            currRole: entity.currRole,
            language: entity.language,
            submitPaperFlag: entity.submitPaperFlag
          }
          var menuList = []
          console.log('MyHeader.vue',entity.ifChair)
          if (entity.ifChair) {
            menuList = chairMenuList
            user.currRole = 'Chair'
          } else {
            for (let i in orgMenuList) {
              if (orgMenuList[i].roleTitle === user.currRole) {
                // if (self.conferenceId == 902 || self.conferenceId == "902") {
                if (localStorage.getItem('isShowCertificate') == '1') {
                  menuList = orgMenuList[i].list;
                } else {
                  let menuList901 = JSON.parse(JSON.stringify(orgMenuList[i].list))
                  for (let item of menuList901) {
                    item.details.forEach((value, index, array) => {
                      if (value.name == "Certificate") {
                        array.splice(index,1)
                      }
                    });
                  }
                  menuList = menuList901
                }
              }
            }
          }
          console.log('set-menuData', '1')
          localStorage.setItem('menuData', JSON.stringify(menuList))
          localStorage.setItem('user', JSON.stringify(user))
          localStorage.setItem('roleList', JSON.stringify(roleList))
          localStorage.setItem('language', user.language)
          location.reload()
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    resetPwd: function () {
      if (this.$refs.pwdForm.rules) {
        this.$refs.pwdForm.clearValidate()
      }
      this.editPwdVisible = true
      this.pwdForm = {
        conferenceId: this.user.conferenceId,
        adminName: this.user.userEmail,
        password: '',
        passwordConfirm: ''
      }
    },
    savePwdSubmit: function () {
      this.$refs.pwdForm.validate((valid) => {
        if (valid) {
          if (this.user.ifCochair) {
            this.$myaxios.post('cochair/update/password', {
              password: Md5(this.pwdForm.password)
            })
              .then(function (response) {
                if (response.data.code === '0000') {
                  this.editPwdVisible = false
                }
              }.bind(this))
              .catch(function (error) {
                console.log(error)
              })
          } else if (this.user.ifChair) {
            this.$myaxios.post('chair/curr/update/password', {
              password: Md5(this.pwdForm.password),
              conferenceId: this.pwdForm.conferenceId
            })
              .then(function (response) {
                if (response.data.code === '0000') {
                  this.editPwdVisible = false
                }
              }.bind(this))
              .catch(function (error) {
                console.log(error)
              })
          }
        }
      })
    },
    showPass () {
      if (this.show === 'text') {
        this.show = 'password'
      } else {
        this.show = 'text'
      }
    },
    showPassConfirm () {
      if (this.showConfirm === 'text') {
        this.showConfirm = 'password'
      } else {
        this.showConfirm = 'text'
      }
    },
    logout: function () {
      this.$myaxios.post('logout', {
      })
        .then(function (response) {
          var code = response.data.code
          if (code === '0000') {
            localStorage.removeItem('menuData')
            localStorage.removeItem('user')
            localStorage.removeItem('roleList')
            localStorage.removeItem('language')
            localStorage.removeItem('invitationCode')
            localStorage.removeItem('sessionId')
            localStorage.removeItem('subDate')
            localStorage.removeItem('subTime')
            this.$router.push({name: 'login'})
          }
        }.bind(this))
        .catch(function (error) {
          console.log(error)
        })
    },
    pwdValidator: function (rule, value, callback) {
      var password = this.pwdForm.password
      if (!value) {
        return callback(new Error(this.$t('header.rule.passwordConfirm')))
      } else if (password === value) {
        callback()
      } else {
        return callback(new Error(this.$t('header.rule.passwordNotEqual')))
      }
    },
    toggleSideBar() {
      this.$store.commit('app/SET_COLLAPSE')
    }
  }
}
</script>

<style scoped>
  .el-header {
    background-color: #950e0a;
    color: #fff;
    line-height: 80px;
    padding: 0px;
    box-shadow: 0px 5px 0px 0px #f5f5f5;
    position: relative;
  }
  .toggle {
    font-size: 22px;
    width: 20px;
    line-height: 60px;
    height: 100%;
    cursor: pointer;
    transition: background .3s;
    position: absolute;
    left: 15px;
    top: 0;
    font-weight: 400;
  }
  #breadcrumb {
    position: absolute;
    left: 40px;
    top: 0;
    line-height: 60px;
    height: 100%;

  }


  .el-menu{
    position: absolute;
    right: 0;
    border: 0;
    background-color: #950e0a;
  }
  .el-menu-item{
    color: #c0c0c0;
  }
  .menu-title {
    color: #3C7A95;
    font-weight: bold;
    background-color: #f0f0f0;
    padding: 15px;
    border-radius: 50%;
  }
  .menu-left {
    position: relative;
    right: 400px;
  }
  .router_link{
    text-decoration: none;
  }
  /* .my_breadcrumbs{
    margin-top: 20px;
    margin-left: 10px;
  } */
  .topLab{
    margin: 0;
    padding: 0;
  }




  
</style>



// WEBPACK FOOTER //
// src/components/MyHeader.vue